import React from 'react'
import { QuickLinkWrapper, FooterWrapper, NavLink, QuickLinkGrid, LinkHeader, SocialIcons } from './Footer.style'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';


export function Footer() {
  return (
    <>
        <FooterWrapper>
            <div>
                <img src="img/Bonpellz Logo (PNG) 3.png" alt="" />
            </div>
            <p>
                Bonpellz is a holistic solution to an incredible savings and investment spree that enables you to start building wealth and
                achieve financial freedom via financial literacy.
            </p>
            <QuickLinkWrapper>
                <QuickLinkGrid>
                    <LinkHeader to="">Company</LinkHeader>
                    <ul>
                        <li><NavLink to="/about">About Us</NavLink></li>
                        <li><NavLink to="/blog">Blog</NavLink></li>
                        <li><NavLink to="/faqs">FAQS</NavLink></li>

                    </ul>
                </QuickLinkGrid>
                <QuickLinkGrid>
                    <LinkHeader to="">Quick Access</LinkHeader>
                    <ul>
                        <li><NavLink to="/target-savings">Speedy Keep</NavLink></li>
                        <li><NavLink to="/coming-soon">Transfer Lock</NavLink></li>
                        <li><NavLink to="/coming-soon">Manage Plan</NavLink></li>
                        <li><NavLink to="/coming-soon">Crowd Funding</NavLink></li>


                    </ul>
                </QuickLinkGrid>
                <QuickLinkGrid>
                    <LinkHeader to="">Products</LinkHeader>
                    <ul>
                        <li><NavLink to="/automatic-debiting">Cybernate</NavLink></li>
                        <li><NavLink to="/invest-dollars">Wealthify</NavLink></li>
                        <li><NavLink to="/digital-wallet">Bz pool</NavLink></li>
                        <li><NavLink to="/smart-savings">Savings plan</NavLink></li>
                        <li><NavLink to="/investment">Investment Plans</NavLink></li>
                        <li><NavLink to="/virtual-debit-card">Virtual debit Card</NavLink></li>
                        <li><NavLink to="/target-saving-goals">Overdraft (Bonpellz enabler)</NavLink></li>
                        <li><NavLink to="/save-plan-pin">Hexa virtual account</NavLink></li>


                    </ul>
                </QuickLinkGrid>
                <QuickLinkGrid>
                    <LinkHeader to="">Legal</LinkHeader>
                    <ul>
                        <li><NavLink to="/">Terms Of use</NavLink></li>
                        <li><NavLink to="/">Privacy policy</NavLink></li>
                      

                    </ul>
                </QuickLinkGrid>
                <QuickLinkGrid>
                    <LinkHeader to="">Connect With us</LinkHeader>
                    <SocialIcons>
                        <li><a href="https://www.facebook.com/Bonpellz"><FacebookIcon sx={{fontSize:"150%"}}/></a></li>
                        <li><a href="https://www.instagram.com/invites/contact/?i=my8n3lnf1cpl&utm_content=le8fgoa"><InstagramIcon sx={{fontSize:"150%"}}/></a></li>
                        <li><a href="https://twitter.com/Bonpellzhq?s=09"><TwitterIcon sx={{fontSize:"150%"}}/></a></li>
                        <li><a href="https://www.linkedin.com/company/bonpellz/"><LinkedInIcon sx={{fontSize:"150%"}}/></a></li>
                        <li><a href="/"><YouTubeIcon sx={{fontSize:"150%"}}/></a></li>
                    </SocialIcons>
                </QuickLinkGrid>
            
              
                <QuickLinkGrid>
                    <LinkHeader to="">Contact</LinkHeader>
                    <ul>
                        <li><NavLink to="/">admin@bonpellz.com</NavLink></li>
                        <li><NavLink to="/">info@bonpellz.com</NavLink></li>
                        <li><NavLink to="/">support@bonpellz.com</NavLink></li>
                        <li><p>08151003534</p></li>
                     

                    </ul>
                </QuickLinkGrid>
            </QuickLinkWrapper>
            <span style={{textAlign:'center'}}>©2022(Bonpellz savings and investment BSI)   All right reserved	</span>
        </FooterWrapper>
    </>
  )
}

